import * as types from '../constants';
import LocalstorageUtility from '../common/localStorageUtility/localStorageUtility';

const initialState = {
  favouritesCounter: LocalstorageUtility.getPreferredCounter(),
  sessionCounter: LocalstorageUtility.getSessionCounter(),
};

export default function localStorageReducer(state = initialState, action) {
  switch (action.type) {
    case types.FAVOURITES_MATCH:
      LocalstorageUtility.updateMatch(action.sportId, action.matchId, action.currentDate);
      return {
        ...state,
        favouritesCounter: LocalstorageUtility.getPreferredCounter(),
      };
    case types.REMOVE_FAVOURITES_MATCH_FROM_LOCALSTORAGE:
      LocalstorageUtility.updateMatch(action.sportId, action.gameId, action.date);
      return {
        ...state,
        favouritesCounter: LocalstorageUtility.getPreferredCounter(),
      };
    case types.CLEAR_LOCAL_STORAGE:
      LocalstorageUtility.clearStorage();
      return initialState;
    case types.UPDATE_LOCAL_STORAGE:
      LocalstorageUtility.updateLocalStorage();
      return {
        ...state,
        favouritesCounter: LocalstorageUtility.getPreferredCounter(),
      };
    case types.INCREMENT_SESSION_COUNTER:
      LocalstorageUtility.incrementSessionCounter();
      return {
        ...state,
        sessionCounter: LocalstorageUtility.getSessionCounter(),
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/localStorage.js